import styled from 'styled-components'

export const Container = styled.div`
  width: ${props => props.width || '350px'};
`
